const NUMBER_BLACKLIST = new Set([
  'psa', 'bgs', 'sgc', 'cgc', 'hga', 'csg', 'dna', 'loa', 'jsa', 'raw',
]);

const NOISE_PATTERNS = [
  /\b(?:PSA|BGS|SGC|CGC|HGA|CSG)\s*\d+(?:\.\d+)?\b/gi,
  /\b(?:PSA|BGS|SGC|CGC|HGA|CSG)\b/gi,
  /\bcert\.?\s*#?\s*[A-Za-z0-9-]+\b/gi,
  /\b(?:raw|ungraded|not\s+graded)\b/gi,
  /\b(?:free|fast|priority|combined)\s+shipping\b/gi,
  /\bnew\s+listing\b/gi,
  /\bauthentic\b/gi,
];

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function cleanSetText(value) {
  return String(value)
    .replace(/[|/]+/g, ' ')
    .replace(/\s*[-–—,]+\s*/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/^[\s\-–—,:;]+|[\s\-–—,:;]+$/g, '')
    .trim();
}

/**
 * Best-effort parse of year, card number, and remaining text as set from a sale listing title.
 * Does not split set vs variation — leftover text goes into set for the user to edit.
 *
 * @param {string} title
 * @param {{ player?: string }} [options]
 * @returns {{ year: string, number: string, set: string }}
 */
export function parseCollectionCardFromSaleTitle(title, options = {}) {
  if (!title || typeof title !== 'string') {
    return { year: '', number: '', set: '' };
  }

  let remaining = title.trim();
  if (!remaining) {
    return { year: '', number: '', set: '' };
  }

  let year = '';
  const leadingYear = remaining.match(/^(\d{4}(?:-\d{2,4})?)\b/);
  if (leadingYear) {
    year = leadingYear[1];
    remaining = remaining.slice(leadingYear[0].length);
  } else {
    const anyYear = remaining.match(/\b((?:19|20)\d{2}(?:-\d{2,4})?)\b/);
    if (anyYear) {
      year = anyYear[1];
      remaining = `${remaining.slice(0, anyYear.index)} ${remaining.slice(anyYear.index + anyYear[0].length)}`;
    }
  }

  let number = '';
  const numberMatch = remaining.match(/(?:#\s*|No\.?\s+)([A-Za-z0-9-]{1,15})\b/i);
  if (numberMatch && !NUMBER_BLACKLIST.has(numberMatch[1].toLowerCase())) {
    number = numberMatch[1];
    remaining = `${remaining.slice(0, numberMatch.index)} ${remaining.slice(numberMatch.index + numberMatch[0].length)}`;
  }

  NOISE_PATTERNS.forEach((pattern) => {
    remaining = remaining.replace(pattern, ' ');
  });

  const player = typeof options.player === 'string' ? options.player.trim() : '';
  if (player) {
    remaining = remaining.replace(new RegExp(`\\b${escapeRegExp(player)}\\b`, 'gi'), ' ');
  }

  return {
    year,
    number,
    set: cleanSetText(remaining),
  };
}

/**
 * Merge title-parsed fields onto a collection card draft when missing.
 * Skips when cert is present so httpbuildcollectioncard can still run (!card.set).
 *
 * @param {object} card
 * @param {string} title
 * @returns {object}
 */
export function applySaleTitleToCollectionCard(card, title) {
  if (!card || card.cert || !title) {
    return card;
  }

  const parsed = parseCollectionCardFromSaleTitle(title, { player: card.player });

  if (!card.year && parsed.year) {
    card.year = parsed.year;
  }

  if (!card.number && parsed.number) {
    card.number = parsed.number;
  }

  if (!card.set && parsed.set) {
    card.set = parsed.set;
  }

  return card;
}
